import { env as Environment } from "@/env"

console.log('运行环境',Environment)

export const getGraphqlHost = () => {
    const map = {
        test: '//test-m.focus.cn',
        pre: '//graphql.focus.cn',
        prod: '//graphql.focus.cn',
    }
    return map[Environment]
}

export const getClueSend = () => {
    const map = {
        test: '//test-www.focus.cn',
        pre: '//relay.focus.cn',
        prod: '//relay.focus.cn',
    }

    return map[Environment]
}

export const getUcenterHost = () => {
    const map = {
        test: '//test-m.focus.cn/userLogin',
        pre: '//login.focus.cn',
        prod: '//login.focus.cn'
    }
    return map[Environment]
}
// 反馈意见
export const getSuggestHost = () => {
    // 动态拼接域名
    const cityPrefix = window?.focusArticleData?.authorSelectCityPrefix || window?.focusArticleData?.authorIpCityPrefix || 'house' //与导航栏城市保持一致
    const map = {
        test: `//${cityPrefix}.focus-test.cn`,
        pre: `//${cityPrefix}.focus.cn`,
        prod: `//${cityPrefix}.focus.cn`,
    }
    return map[Environment]
}

export const getFocusHost = () => {
    const map = {
        test: '//test-www.focus.cn',
        pre: '//article.focus.cn',
        prod: '//article.focus.cn',
    }
    return map[Environment]
}

// 获取微信开放服务api对应host
export const getWxOpenApiHost = () => {
    const map = {
        test: '//test-www.focus.cn/wx-open-api',
        pre: '//wx-open-api.focus.cn',
        prod: '//wx-open-api.focus.cn',
    }
    return map[Environment]
}

// 获取用户中心host
export const getUisURL = () => {
    const map = {
        test: '//test-uis.mp.sohu.com',
        pre: '//uis.mp.sohu.com',
        prod: '//uis.mp.sohu.com',
    }
    return map[Environment]
}
export const getWelfareHost = () => {
    const map = {
        test: '//dsp-welfare.focus-test.cn',
        pre: '//dsp-welfare.focus.cn',
        prod: '//dsp-welfare.focus.cn',
    }
    return map[Environment]
}
